import type { InventoryHistoryPoint } from './types';
import { t } from '../lib/i18n';

export async function fetchInventoryHistory(): Promise<InventoryHistoryPoint[]> {
  const res = await fetch('/api/inventory-history', { credentials: 'same-origin' });
  if (res.status === 503) throw new Error('inventory-history cache not ready');
  if (res.status === 502) throw new Error(t.errors.daemonOffline);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return (await res.json()) as InventoryHistoryPoint[];
}
